import { render, staticRenderFns } from "./Privacypolicy.vue?vue&type=template&id=b172d6c4&"
import script from "./Privacypolicy.vue?vue&type=script&lang=js&"
export * from "./Privacypolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports